import './saved.scss';

import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FeatureFlag } from 'hellospa/components/feature-flags';
import Signature from './signature';
import Pagination from '../pagination';
import CONSTANTS from '../../../common/signature-modal/constants';

class Saved extends React.PureComponent {

  onSelectSignature = (signature) => () => {
    // HACK Unfortunately we have to do this to support
    // legacy code.
    window.primarySignatureGuid = signature.guid;

    this.selectSignature(signature);
  };

  componentDidMount() {
    if (window.primarySignatureGuid) {
      for (let i = 0, len = this.props.signatures.length; i < len; i++) {
        const signature = this.props.signatures[i];

        if (signature.guid === window.primarySignatureGuid) {
          this.props.onSavedSignatureSelect(signature);
        }
      }
    } else if (!this.props.selectedSavedSignature && this.props.signatures.length) {
      const firstSignature = this.props.signatures[0];

      this.props.onSavedSignatureSelect(firstSignature);
    }
    this.fetchPaginatedSignatures();
    this.props.enableInsertButtonCallback(this.shouldEnableInsert());
  }

  componentDidUpdate() {
    this.props.enableInsertButtonCallback(this.shouldEnableInsert());
  }

  selectSignature(signature) {
    this.props.onSavedSignatureSelect(signature);
  }

  getSignatureData() {
    return this.props.selectedSavedSignature;
  }

  shouldEnableInsert() {
    return this.props.signatures.length && !!this.props.selectedSavedSignature;
  }

  fetchPaginatedSignatures = (page = 1) => {
    if (this.props.getPaginatedSignatures) {
      this.props.getPaginatedSignatures(this.props.type, page);
    }
  };

  render() {
    const {
      selectedSavedSignature,
      signatures,
      onSavedSignatureRemove,
      getSignatureUrl,
      type,
      count,
    } = this.props;
    let noSignaturesMessage;
    let itemsPerPage;
    if (type === CONSTANTS.TYPE_SIGNATURE) {
      noSignaturesMessage = (
        <FormattedMessage
          id=""
          description="Notice shown to the user when they do not have any saved signatures"
          defaultMessage="To create a signature select an option in one of the tabs. Signatures you’ve created will appear here." />
      );
      itemsPerPage = CONSTANTS.SIGNATURES_PER_PAGE;
    } else {
      noSignaturesMessage = (
        <FormattedMessage
          id=""
          description="Notice shown to the user when they do not have any saved initials"
          defaultMessage="To create initials select an option in one of the tabs. Initials you’ve created will appear here." />
      );
      itemsPerPage = CONSTANTS.INITIALS_PER_PAGE;
    }
    return (
      <div>
        {signatures.length ? (
          <div className="signature-modal-saved__saved-signatures">
            <div className="signature-modal-saved__choose-signature-container">
              <ol className="signature-modal-saved__choose-signature-list" data-qa-ref="signing-modal--saved-signatures">
                {this.props.signatures.map((signature, i) => (
                  <li
                    className="signature-modal-saved__choose-signature-list-item"
                    key={signature.guid}
                    data-qa-ref={`carousel-item-${i}`}
                  >
                    <div
                      className="signature-modal-saved__signature-container"
                      onClick={this.onSelectSignature(signature)}
                    >
                      <Signature
                        isSelected={
                          selectedSavedSignature
                            ? signature.guid === selectedSavedSignature.guid
                            : false
                        }
                        signature={signature}
                        signatureSrc={getSignatureUrl(signature)}
                        onDelete={onSavedSignatureRemove} />
                    </div>
                  </li>
                ))}

              </ol>
            </div>
          </div>
        ) : noSignaturesMessage}
        <FeatureFlag name='HelloSign_Rollout_Paginate_Signatures'>
          <Pagination
            collection={{ count, itemsPerPage }}
            handlePageChange={this.fetchPaginatedSignatures} />
        </FeatureFlag>
      </div>
    );
  }
}

export default injectIntl(Saved, { forwardRef: true });
